import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import StarIcon from "@mui/icons-material/Star";
import { reviews, videoStories, youtubeUrl } from "../../data/specialTour";
import { ContentBand, Inner, KakaoButton, PageIntro, SectionHeader, SpecialTourLayout } from "./SpecialTourLayout";

export function ReviewsPage() {
  return (
    <SpecialTourLayout>
      <PageIntro
        eyebrow="Reviews"
        title="다녀온 팀의 분위기를 리뷰와 영상으로 확인하세요"
        body="공개 가능한 이용 후기를 홈페이지용으로 정리했습니다. 영상 원본은 용량이 커서 채널과 문의 링크 중심으로 안내합니다."
        image="/special-tour-assets/thanks.jpg"
      />
      <ContentBand className="bg-white">
        <Inner>
          <SectionHeader title="이용 후기" body="라운드, 이동, 식사, 자유여행까지 전체 경험을 기준으로 정리했습니다." />
          <div className="grid gap-5 md:grid-cols-3">
            {reviews.map((review) => (
              <article key={review.title} className="rounded-lg border border-[#dce3d8] bg-[#fbfaf6] p-6 shadow-sm">
                <div className="mb-4 flex items-center gap-1 text-[#d16339]">
                  <StarIcon sx={{ fontSize: 18 }} />
                  <span className="text-sm font-900">{review.rating}</span>
                </div>
                <h2 className="text-xl font-900 leading-tight text-[#15391f]">{review.title}</h2>
                <div className="mt-3 flex flex-wrap gap-2 text-xs font-800 text-[#697469]">
                  <span>{review.date}</span>
                  <span>{review.people}</span>
                </div>
                <p className="mt-4 text-sm leading-7 text-[#596559]">{review.body}</p>
                {review.link ? (
                  <a
                    href={review.link}
                    className="mt-5 inline-flex items-center gap-2 text-sm font-900 text-[#1d5d31] hover:text-[#15391f]"
                  >
                    관련 이미지 보기
                    <OpenInNewIcon sx={{ fontSize: 16 }} />
                  </a>
                ) : null}
              </article>
            ))}
          </div>
        </Inner>
      </ContentBand>
      <ContentBand>
        <Inner>
          <SectionHeader title="투어 영상" body="대용량 원본은 별도로 보관하고, 홈페이지에서는 웹용 영상과 유튜브 채널로 안내합니다." />
          <div className="grid gap-5 md:grid-cols-3">
            {videoStories.map((story) =>
              story.videoSrc ? (
                <article key={story.title} className="rounded-lg border border-[#dce3d8] bg-white p-4 shadow-sm">
                  <div className="overflow-hidden rounded-lg bg-black">
                    <video
                      controls
                      preload="metadata"
                      poster={story.poster}
                      className="aspect-[3/4] w-full bg-black object-contain"
                    >
                      <source src={story.videoSrc} type="video/mp4" />
                    </video>
                  </div>
                  <div className="mt-5 px-2 pb-2">
                    <div className="text-sm font-900 text-[#d16339]">{story.location}</div>
                    <h2 className="mt-2 text-xl font-900 leading-tight text-[#15391f]">{story.title}</h2>
                    <p className="mt-3 text-sm font-700 text-[#697469]">{story.size}</p>
                    <p className="mt-4 text-sm leading-7 text-[#596559]">{story.description}</p>
                  </div>
                </article>
              ) : (
                <a
                  key={story.title}
                  href={story.href ?? youtubeUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-lg border border-[#dce3d8] bg-white p-6 shadow-sm transition hover:border-[#8faa87] hover:shadow-md"
                >
                  <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-[#e8f2e6] text-[#1e6b34]">
                    <PlayCircleOutlineIcon />
                  </div>
                  <div className="text-sm font-900 text-[#d16339]">{story.location}</div>
                  <h2 className="mt-2 text-xl font-900 leading-tight text-[#15391f]">{story.title}</h2>
                  <p className="mt-3 text-sm font-700 text-[#697469]">{story.size}</p>
                  <p className="mt-4 text-sm leading-7 text-[#596559]">{story.description}</p>
                </a>
              )
            )}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href={youtubeUrl}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-lg bg-[#15391f] px-5 text-sm font-900 text-white transition hover:bg-[#1e542e]"
            >
              YouTube 채널 보기
              <OpenInNewIcon sx={{ fontSize: 17 }} />
            </a>
            <KakaoButton label="영상 포함 일정 문의" />
          </div>
        </Inner>
      </ContentBand>
    </SpecialTourLayout>
  );
}
